import { Component } from "@angular/core";

@Component({
  selector: "app-logo-us-news",
  templateUrl: "logo-us-news.component.html",
})
export class LogoUSNewsComponent {}
